import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { haptics } from '../utils/haptics';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const role = user?.role || 'patient';
  const [showReelMenu, setShowReelMenu] = useState(false);

  const getNavItems = () => {
    if (role === 'patient') {
      return [
        { id: 'home', label: 'Home', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
        { id: 'subscription', label: 'Plans', icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
        { id: 'consultation', label: 'Session', icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' },
        { id: 'doctors', label: 'Providers', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' },
        { id: 'reels', label: 'Reels', icon: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' },
        { id: 'profile', label: 'Profile', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' }
      ];
    } else if (role === 'clinic' || role === 'hospital') {
      return [
        { id: 'home', label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
        { id: 'wallet', label: 'Wallet', icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z' },
        { id: 'reels', label: 'Reels', icon: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' },
        { id: 'profile', label: 'Profile', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' }
      ];
    } else if (['doctor', 'clinic_doctor', 'hospital_doctor'].includes(role)) {
      return [
        { id: 'home', label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
        { id: 'consultation', label: 'Session', icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' },
        { id: 'patients', label: 'Users', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' },
        { id: 'wallet', label: 'Wallet', icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z' },
        { id: 'reels', label: 'Reels', icon: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' },
        { id: 'profile', label: 'Profile', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' }
      ];
    } else if (role === 'retailer') {
      return [
        { id: 'home', label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
        { id: 'products', label: 'Products', icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4' },
        { id: 'orders', label: 'Orders', icon: 'M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z' },
        { id: 'wallet', label: 'Wallet', icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z' },
        { id: 'reels', label: 'Reels', icon: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' },
        { id: 'profile', label: 'Profile', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' }
      ];
    }

    // Default fallback
    return [
      { id: 'home', label: 'Home', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
      { id: 'profile', label: 'Profile', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' }
    ];
  };

  const navItems = getNavItems();

  const isCreator = ['doctor', 'clinic_doctor', 'hospital_doctor', 'clinic', 'hospital', 'retailer'].includes(role);

  const handleNavigation = (itemId) => {
    haptics.impact('LIGHT');

    // Show popup for creator roles clicking reels
    if (itemId === 'reels' && isCreator) {
      setShowReelMenu(true);
      return;
    }

    const effectiveRole = ['clinic_doctor', 'hospital_doctor'].includes(role) ? 'doctor' : role;
    const basePath = `/dashboard/${effectiveRole}`;

    // Patient-specific routing
    if (role === 'patient') {
      switch (itemId) {
        case 'home':
          navigate('/patient/home');
          break;
        case 'subscription':
          navigate('/patient/subscription');
          break;
        case 'consultation':
          navigate('/patient/consultation');
          break;
        case 'doctors':
          navigate('/patient/doctors');
          break;
        case 'reels':
          navigate('/reels');
          break;
        case 'profile':
          navigate('/patient/profile');
          break;
        default:
          navigate('/patient/home');
      }
    } else {
      // Other roles use dashboard routing
      switch (itemId) {
        case 'home':
          navigate(`${basePath}/home`);
          break;
        case 'consultation':
          navigate(`${basePath}/consultation`);
          break;
        case 'patients':
          navigate(`${basePath}/patients`);
          break;
        case 'products':
          navigate(`${basePath}/products`);
          break;
        case 'orders':
          navigate(`${basePath}/orders`);
          break;
        case 'wallet':
          navigate(`${basePath}/wallet`);
          break;
        case 'reels':
          navigate('/reels');
          break;
        case 'profile':
          navigate(`${basePath}/profile`);
          break;
        default:
          navigate(`${basePath}/home`);
      }
    }
  };

  const isActive = (itemId) => {
    if (role === 'patient') {
      const patientPaths = {
        'home': '/patient/home',
        'subscription': '/patient/subscription',
        'consultation': '/patient/consultation',
        'doctors': '/patient/doctors',
        'reels': '/reels',
        'profile': '/patient/profile'
      };
      return location.pathname === patientPaths[itemId];
    } else {
      const effectiveRole = ['clinic_doctor', 'hospital_doctor'].includes(role) ? 'doctor' : role;
      const basePath = `/dashboard/${effectiveRole}`;
      if (itemId === 'home') {
        return location.pathname === `${basePath}/home`;
      }
      return location.pathname.startsWith(`${basePath}/${itemId}`);
    }
  };

  return (
    <>
      {/* Reel menu popup for creators */}
      {showReelMenu && (
        <div className="fixed inset-0 z-50 flex items-end justify-center" onClick={() => setShowReelMenu(false)}>
          <div className="absolute inset-0 bg-black/50" />
          <div className="relative bg-gray-900 rounded-t-2xl w-full max-w-lg p-6 pb-10 border-t border-gold"
            onClick={e => e.stopPropagation()}>
            <div className="w-10 h-1 bg-gray-600 rounded-full mx-auto mb-6" />
            <h3 className="text-lg font-semibold text-light text-center mb-5">Reels</h3>
            <div className="space-y-3">
              <button onClick={() => { setShowReelMenu(false); navigate('/reels'); }}
                className="w-full bg-gray-800 text-light rounded-xl p-4 flex items-center gap-4 hover:bg-gray-700 transition-colors">
                <span className="text-2xl">📹</span>
                <div className="text-left">
                  <p className="font-medium">Watch Reels</p>
                  <p className="text-sm text-gray-400">Browse reels from all creators</p>
                </div>
              </button>
              <button onClick={() => { setShowReelMenu(false); navigate('/reels/profile'); }}
                className="w-full bg-gray-800 text-light rounded-xl p-4 flex items-center gap-4 hover:bg-gray-700 transition-colors">
                <span className="text-2xl">👤</span>
                <div className="text-left">
                  <p className="font-medium">My Reels Profile</p>
                  <p className="text-sm text-gray-400">View your reels, likes, views & analytics</p>
                </div>
              </button>
              <button onClick={() => { setShowReelMenu(false); navigate('/reels/subscription'); }}
                className="w-full bg-gold text-dark rounded-xl p-4 flex items-center gap-4 font-semibold">
                <span className="text-2xl">➕</span>
                <div className="text-left">
                  <p className="font-medium">Upload Reel</p>
                  <p className="text-sm text-dark/70">Subscription required to upload</p>
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      <nav className="w-full bg-dark border-t border-gold pt-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))] px-4 shadow-[0_-4px_20px_rgba(0,0,0,0.5)]">
        <div className="flex justify-around">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNavigation(item.id)}
              className={`flex flex-col items-center py-2 px-3 rounded-lg transition-colors ${isActive(item.id)
                ? 'bg-gold text-dark'
                : 'text-light hover:bg-gray-900'
                }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={item.icon}
                />
              </svg>
              <span className="text-xs mt-1">{item.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
